import React, {ReactNode} from "react";
import {Box, Dialog, DialogContent, DialogTitle, Typography} from "@mui/material";
import {useTheme} from "../../../contexts/theme";
import CancelIcon from "@mui/icons-material/Cancel";

interface StyledPopupProps {
    width?: string;
    height?: string;
    fullWidth?: boolean;
    isOpen: boolean;
    onClose: () => void;
    children?: ReactNode;
    title?: ReactNode;
}

const StyledPopup: React.FC<StyledPopupProps> = ({height, width, isOpen, children, onClose, title, fullWidth = true}) => {
    const theme = useTheme();

    return (<Dialog onClose={onClose} open={isOpen} fullWidth={fullWidth}
                    maxWidth={false}
                    PaperProps={{
                        sx: {
                            width: width,
                            height: height,
                            backgroundColor: theme.palette.blue,
                            overflow: 'hidden',
                            padding: theme.spacing.md,
                            display: 'flex'
                        },
                    }}>
        <DialogTitle sx={{padding: theme.spacing.none}}>
            <Box sx={{justifyContent: 'space-between', display: 'flex', width: '100%'}}>
                {(typeof title === 'string') ?
                    <Typography sx={{color: theme.palette.white, fontSize: theme.fontSizes.title, fontWeight: theme.fontWeights.title}}>{title}</Typography>
                    : <>{title}</>}
                <CancelIcon sx={{fontSize: theme.fontSizes.title, color: theme.palette.orange, cursor:'pointer'}} onClick={onClose} />
            </Box>
        </DialogTitle>
        <DialogContent sx={{padding: theme.spacing.none}}>
            {children}
        </DialogContent>
    </Dialog>
    )
};

export default StyledPopup;